<template>
  <div class="white_bg">
    <div class="filter_config_container" :style="{'height':is_show?'236px':'110px'}">
      <template v-for="(item) in filterConditionRef" :key="item.field">
        <div class="config_item">
          <div class="config_label">{{ item.field }} :</div>
          <div class="config_list flex flex_wrap">
            <span
              :class="[
                !filterSelectedData[item.field].selectedText ? 'current' : '',
              ]"
              @click="changeFilterSelectedData(item.field, config, '')"
              style="padding: 0 10px"
              >不限</span
            >
            <span
              :class="[
                filterSelectedData[item.field].selectedText == config.text
                  ? 'current'
                  : '',
              ]"
              v-for="config of item.list"
              :key="config.text"
              @click="changeFilterSelectedData(item.field, config, config.text)"
              >{{ config.text }}</span
            >
          </div>
        </div>
      </template>
      <div class="show_or_hide" @click="is_show = !is_show">
        <div>
          {{ is_show ? "点击收起" : "展开更多" }}
        </div>
      </div>
    </div>
    <div class="car_list"  v-loading="data_loading" element-loading-text="数据加载中">
      <div class="car_item flex" v-for="item of carData" :key="item.report_id">
        <div class="car_img_box">
          <img :src="item.model_img" />
        </div>
        <div class="car_msg">
          <div class="car_msg_top flex_between">
            <div class="car_name">
              {{ item.brand + " " + item.model_name }}
            </div>
            <div class="flex">
              <div class="synthesize_score">
                综合得分：<strong>{{ item.total_score }}</strong>
              </div>
              <div class="synthesize_rank">
                综合排名：<strong class="color_E7816E">{{ item.top }}</strong>
              </div>
            </div>
          </div>
          <div class="car_msg_mid flex">
            <div class="car_model">车型：年款 {{ item.year }}</div>
            <div class="energe_type">
              能源：{{ getEnergyType(item.energy_type) }}
            </div>
            <div class="synthesize_rank">指导价：{{ item.price }}万元</div>
          </div>
          <div class="to_detail_btns flex">
            <router-link
              class="to_detail_btn"
              :to="{ path: '/report/summary', query: { model_id: item.id } }"
              >测评详情</router-link
            >
            <router-link
              class="to_detail_btn"
              :to="{ 
                path: '/summary/first', 
                query: {
                  model_img:item.model_img,
                  model_name: item.short_name||data.model_name,
                  model_id: item.id,
                  report_id: item.report_id
                }
              }"
              >功能标杆分析</router-link
            >
            <router-link
              class="to_detail_btn"
              :to="{
                path: '/contrast/analyse/base',
                query: { 
                  model_img:item.model_img,
                  model_name: item.short_name||item.model_name,
                  model_id: item.id,
                  report_id: item.report_id 
                },
              }"
              >数据分析</router-link
            >
            <div class="to_detail_btn" @click="openCarAttrDrawer(item.id)">
              车型参数
            </div>
            <div
              :class="contrastListIds.indexOf(item.id) == -1 ? 'to_detail_btn add_btn' : 'to_detail_btn cancel_btn' "
              @click="checkChange(item, contrastListIds.indexOf(item.id) == -1)"
            >
              {{ contrastListIds.indexOf(item.id) == -1 ? "添加" : "取消" }}对比
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="report_compare_btn">
      <template v-if="contrastListRef && contrastListRef.length > 0">
        <div
          class="contrast_item flex_center flex_between"
          v-for="car of contrastListRef"
          :key="car.model_id"
        >
          <span>{{ car.model_name }}</span>
          <el-icon @click.stop="delCompareCar(car)" style="cursor: pointer"
            ><close-bold :color="'#96A6CA'"
          /></el-icon>
        </div>
      </template>
      <p class="car_num">
        已选{{ (contrastListRef && contrastListRef.length) || 0 }}款车型
      </p>
      <button class="to_page_btn" @click.self="toContrastPage">测评对比</button>
    </div>
    <CarAttr ref="carAttrDrawer" />
  </div>
</template>

<script>
import { ref, reactive, computed, watch } from "vue";
import { getCarFilterConfig, getCarLibrary } from "@/api";
import { ElMessage, ElIcon } from "element-plus";
import { CloseBold } from "@element-plus/icons";
import { getEnergyType } from "@/components/common/js/common.js";
import { useRouter } from "vue-router";
import store from "@/store";
import CarAttr from "@/components/common/views/CarAttr.vue";
export default {
  name: "ChangeModel",
  components: {
    CloseBold,
    ElIcon,
    CarAttr,
    // ElTable,
    // ElTableColumn,
    // ElPagination
  },
  setup() {
    const router = useRouter();
    //筛选项
    const filterConditionRef = ref([]);
    // 筛选项选中的数据
    const filterSelectedData = reactive({});
    //tab签th
    // const thRef = ref([
    //     {
    //       type: 'img',
    //       name: ''
    //     },
    //      {
    //       type: 'brand',
    //       name: '品牌'
    //     },
    //      {
    //       type: 'energy_type_str',
    //       name: '能源'
    //     },
    //      {
    //       type: 'price',
    //       name: '指导价'
    //     },
    //     {
    //       type: 'total_score',
    //       name: '综合得分'
    //     },
    //     {
    //       type: 'top',
    //       name: '综合排名'
    //     }
    // ])
    const getCarFilterConfigData = () => {
      getCarFilterConfig().then((res) => {
        if (res.code == 200) {
          const { condition } = res.data;
          filterConditionRef.value = condition;
          for (let item of condition) {
            filterSelectedData[item.field] = {
              selectedText: "",
              params: {},
            };
          }
        }
      });
    };
    // 点击筛选项
    const changeFilterSelectedData = (type, data, selectedText) => {
      if (filterSelectedData[type].selectedText == selectedText) {
        return;
      }
      filterSelectedData[type].selectedText = selectedText;
      if (data) {
        filterSelectedData[type].params = data.params;
      } else {
        filterSelectedData[type].params = {};
      }
      currentPage.value = 1;
      count.value = 0;
      getCarData();
    };
    const count = ref(0),
      currentPage = ref(1),
      pageSize = ref(9999),
      carData = ref([]);
    const data_loading =ref(false);
    // 获取车型列表数据
    const getCarData = () => {
      data_loading.value = true;
      // const loading = ElLoading.service({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      const data = {
        page: currentPage.value,
        rows: pageSize.value,
      };
      //重新请求list
      let params = {};
      for (let key in filterSelectedData) {
        Object.assign(params, filterSelectedData[key].params);
      }
      getCarLibrary({
        ...data,
        ...params,
      }).then((res) => {
        if (res.code == 1) {
          count.value = res.data.count;
          const list = res.data.list;
          if (data.first_id && list[0] && list[0].id == data.first_id) {
            list[0].isWarning = true;
          }
          carData.value = list;
          console.log("数据", carData.value);
        }
        data_loading.value=false;
        // loading && loading.close();
      });
    };
    getCarFilterConfigData();
    getCarData();

    const contrastListRef = computed(() => store.state.compareCarData2);
    const contrastListIds = ref([]);
    contrastListIds.value =
      (contrastListRef.value &&
        contrastListRef.value.map((item) => {
          return item.model_id;
        })) ||
      [];
    watch(contrastListRef, (new_val) => {
      console.log("watch", new_val);
      contrastListIds.value = new_val.map((item) => {
        return item.model_id;
      });
    });
    const checkChange = (item, type) => {
      //选中
      if (type) {
        const data = store.getCompareCarData2();
        if (data.length >= 3) {
          for (let row of carData.value) {
            if (row.id == item.id) {
              // item.checked = false
              ElMessage.error("只能对比3款车型!");
              break;
            }
          }
          return;
        }
        store.setCompareCarData2({
          model_id: item.id,
          report_id: item.report_id,
          model_name: item.brand + " " + item.model_name,
          model_img: item.model_img,
        });
      } else {
        //取消选中
        store.deleteCompareCarData2(item.id);
      }
    };
    const delCompareCar = (car) => {
      const id = car.model_id;
      store.deleteCompareCarData2(id);
      // for(let item of carData.value){
      //     if(id==item.id){
      //       item.checked = false
      //     }
      // }
    };
    const toContrastPage = () => {
      const data = store.getCompareCarData2();
      if (data && data.length > 0) {
        if (data.length == 1) {
          //跳转到测评单个
          router.push({
            path: "/contrast/analyse/base",
            query: {
              model_img:data[0].model_img,
              model_name: data[0].short_name||data[0].model_name,
              model_id: data[0].model_id,
              report_id: data[0].report_id,
            },
          });
        } else {
          let ids = [];
          for (let item of data) {
            ids.push(item.model_id);
          }
          //跳转到测评多个
          router.push({
            path: "/contrast/multi_analyse/index",
            query: {
              model_id: ids.join(","),
            },
          });
        }
      } else {
        ElMessage.error("请先选择车型!");
      }
    };
    const carAttrDrawer = ref(null);
    const openCarAttrDrawer = (model_id) => {
      carAttrDrawer.value.carAttrDrawer = true;
      carAttrDrawer.value.model_id = model_id;
    };
    const is_show = ref(false);

   

    return {
      filterConditionRef,
      filterSelectedData,
      // thRef,
      count,
      currentPage,
      pageSize,
      carData,
      changeFilterSelectedData,
      getEnergyType,
      checkChange,
      contrastListRef,
      contrastListIds,
      delCompareCar,
      toContrastPage,
      is_show,
      openCarAttrDrawer,
      carAttrDrawer,
      data_loading
    };
  },
};
</script>

<style scoped lang="less">
.btnList {
  height: 28px;
  display: flex;
  margin-top: 10px;
}

.white_bg {
  padding: 26px 53px 63px 53px;
}
.filter_config_container {
  font-size: 14px;
  color: #474747;
  border: solid 1px #e9e9e9;
  padding: 0 20px 0;
  border-radius: 5px;
  height:auto;
  transition: height 500ms;
  overflow: hidden;
  position:relative;
  .config_item {
    line-height: 32px;
  }
  .config_label {
    float: left;
    margin: 5px 0;
    color: #474747;
    font-weight: bold;
  }
  .config_list {
    margin-left: 62px;
    span {
      margin: 8px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      padding: 0 3px;
      white-space: nowrap;
      cursor: pointer;
      &.current {
        background: #ebefff;
      }
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        background: #ebefff;
      }
    }
  }
}


.car_list{
  .car_item{
    width:1090px;
    padding: 29px 26px 10px 0;
    position: relative;
    &::after{
      content: "";
      width: 1030px;
      height: 1px;
      background: #F0F6FF;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    &:last-child{
        border-bottom: none;
        &::after{
            width: 0;
            height: 0;
        }
    }
    .car_img_box{
      width: 200px;
      height: 110px;
      flex-shrink: 0;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .car_msg{
      width:864px;
      .car_msg_top{
        font-size: 16px;
        margin-bottom: 8px;
        .car_name{
          font-size: 16px;
          font-weight: bold;
          color: #474747;
        }
        .synthesize_score{
            position: relative;
            margin-right: 20px;
            padding-left: 13px;
            white-space: nowrap;
            color: #7E7E7E;
            &:after{
                position: absolute;
                content: '';
                width: 3px;
                height: 19px;
                background-color: #DDE5FD;
                border-radius: 1px;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
            strong{
                font-size: inherit;
                display: inline-block;
                margin-left: 0;
                color: #474747;
                font-size: 16px;
            }
        }
        .synthesize_rank{
          color: #7E7E7E;
          strong{
              font-size: 16px;
          }
        }
      }
      .car_msg_mid{
        color:#7E7E7E;
        font-size: 14px;
        &>div{
          margin-right:30px;
        }
      }
      .to_detail_btns{
        margin-top: 15px;
        .to_detail_btn{
            display: block;
            width: 105px;
            height: 30px;
            line-height: 30px;
            border-radius: 3px;
            border: 1px solid #5390F1;
            color: #4C96E9;
            font-size: 14px;
            appearance: none;
            text-decoration: none;
            text-align: center;
            background: #fff;
            margin-right: 22px;
            cursor: pointer;
            &.add_btn{
              border: 1px solid #20cfa1;
              color: #11b086;
            }
            &.cancel_btn{
              border: 1px solid #ccc;
              color: #ccc;
            }
        }
    }
    }
  }
}


.report_compare_btn {
  position: fixed;
  padding-top: 31px;
  bottom: 50px;
  right: 0;
  z-index: 1000;
  width: 230px;
  padding: 20px 10px 20px 20px;
  background: #fff;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.05);
  font-size: 16px;
  color: #000;
  .car_num {
    text-align: center;
    color: #787878;
    font-size: 14px;
    margin: 15px 0 10px 0;
  }
  .to_page_btn {
    display: block;
    margin: 0 auto;
    font-size: 16px;
    color: #000;
    font-weight: bold;
    border: 1px solid #787878;
    width: 60%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    outline: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
  }
  .contrast_item {
    height: 46px;
    font-size: 14px;
    line-height: 1.2;
    background-color: #f9f9f9;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 0 10px;
  }
}
.color_E7816E {
  color: #e7816e;
}
.show_or_hide {
  width: 100%;
  height: 24px;
  background: #fff;
  &>div{
    width: 100px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    margin: 0 auto;
    border: solid 1px #e5e5e5;
    border-bottom: none;
    border-radius: 3px 3px 0 0;
    color: #999;
  }
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
</style>